import "rc-slider/assets/index.css";
import "./index.scss";

import { Range } from "rc-slider";
import React from "react";
import colors from "constants/colors";

export interface CheckboxButtonProps {
  children?: React.ReactNode;
  min: number;
  max: number;
  step: number;
  defaultValue: number[];
  onChangeValue: (value: Array<number>) => void;
}

export const RangeNumber: React.FC<CheckboxButtonProps> = ({
  min,
  max,
  step,
  defaultValue,
  onChangeValue,
}) => {
  return (
    <div className="m-rangenumber">
      <Range
        min={min}
        max={max}
        step={step}
        defaultValue={defaultValue}
        dots
        onChange={value => onChangeValue(value)}
        dotStyle={{
          background: "transparent",
          height: 6,
          width: 6,
          border: "none",
          bottom: 0,
        }}
        railStyle={{
          background: "#E7E7E7",
          height: 2,
        }}
        trackStyle={[
          {
            background: colors.richElectricBlue,
            height: 2,
          },
        ]}
        handleStyle={[
          {
            borderColor: colors.pictonBlue,
            height: 12,
            width: 12,
            backgroundColor: colors.richElectricBlue,
            borderStyle: "solid",
            borderWidth: 1,
            boxShadow: "none",
          },
          {
            borderColor: colors.pictonBlue,
            height: 12,
            width: 12,
            backgroundColor: colors.richElectricBlue,
            borderStyle: "solid",
            borderWidth: 1,
            boxShadow: "none",
          },
        ]}
      />
      <div className="m-rangenumber_wrapcontent">
        <span className="m-rangenumber_start">
          {min.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}đ
        </span>
        <span className="m-rangenumber_end">15.000.000đ</span>
      </div>
    </div>
  );
};
